export default {
  seriesType: 'SeriesType',
  seriesTypeDetail: 'SeriesTypeDetail',
  periodicity: 'Periodicity',
  parentObjectType: 'ParentObjectType'
};
